import { PriceModel } from '@modules/price/price-model';

const { fields } = PriceModel;

export default [
  fields.id,
  fields.amount,
  fields.currency,
  fields.createdAt,
  fields.updatedAt
];
